import styled from 'styled-components';

export const BaseDiv = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const ContentDiv = styled.div`
  flex: 1;
`;